exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.validation-error{margin:0 auto 10px;padding:0\n}\n.validation-error ul{list-style-image:none\n}\n.validation-error li{background-color:#ef7d00;color:white;list-style-image:none;padding:8px 15px;border-radius:10px;-webkit-box-shadow:0px 11px 24px rgba(0,0,0,0.07);box-shadow:0px 11px 24px rgba(0,0,0,0.07)\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-75ea7b67","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/core/components/Forms/CreatePassword.vue
// module id = 1yh2
// module chunks = 1 2 4 5 15 17 18 19 20